export enum TradeSide {
  BUY = 'buy',
  SELL = 'sell',
}

export enum OrderType {
  MARKET_BUY = 'marketBuy',
  MARKET_SELL = 'marketSell',
  STOP_LOSS = 'stopLoss',
  LIMIT_BUY = 'limitBuy',
  REPEAT_INVESTMENT = 'repeatInvestment',
}

export enum QuantityType {
  DOLLARS = 'dollars',
  SHARES = 'shares',
}

export const FIXED_INCOME_LIMIT_BUY_PRICE_MARGIN = 0.05;
export const TAF_FEE_BASE_VALUE = 0.000195;
export const TAF_FEE_MIN_VALUE = 0.01;
